import { serviceHelper } from '../../../../config/service-helper';

// Module level state to handle duplicate initialisation requests
let pendingInitialisation: Promise<void> | null = null;

export const initializeBazaarvoice = (onLoad: () => void, onError: () => void) => {
  if (!serviceHelper.bazaarvoiceJsURL) return;

  // piggy back on existing promise
  if (pendingInitialisation) {
    pendingInitialisation.then(onLoad).catch(onError);
    return;
  }

  pendingInitialisation = new Promise<void>((resolve, reject) => {
    const BVScript = document.createElement('script');

    BVScript.src = serviceHelper.bazaarvoiceJsURL ?? '';
    BVScript.onload = () => resolve();
    BVScript.onerror = () => reject();

    document.head.appendChild(BVScript);
  });

  pendingInitialisation.then(onLoad).catch(onError);
};
